export default {
  checkboxContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  checkbox: (isDropdown: boolean, index: number) => ({
    mt: isDropdown && index === 0 ? 0 : '16px',
    mb: isDropdown ? 0 : '10px',
    display: 'flex',
    flex: 1,
    label: {
      transform: 'translateY(-2px)',
      cursor: 'pointer',
      display: 'inline-flex'
    },
    '&:last-child': {
      mb: 0
    }
  })
};